const STACKED_CLASS = 'is-stacked';

/**
 * Breadcrumb in colonna (classe is-stacked) quando in riga non ci sta.
 * La misura si fa sempre in riga, togliendo la classe per un istante: in colonna l'overflow sparisce
 * e misurare lì farebbe alternare riga/colonna. Togliere e rimettere la classe nello stesso frame non si vede.
 * Una container query scroll-state non basta: non può dare stile al container stesso e creerebbe lo stesso ciclo.
 */
export default function breadcrumbsStack() {
    const breadcrumbs = document.getElementById('breadcrumbs');
    if (!breadcrumbs) return;

    const update = () => {
        breadcrumbs.classList.remove(STACKED_CLASS);
        const overflows = breadcrumbs.scrollWidth > breadcrumbs.clientWidth;
        breadcrumbs.classList.toggle(STACKED_CLASS, overflows);
    };

    /*
     * Il ResizeObserver scatta anche al cambio di altezza dovuto alla classe: la misura dà lo stesso
     * risultato, quindi la classe non cambia e non si innesca un ciclo
     */
    new ResizeObserver(update).observe(breadcrumbs);
    // Il web font cambia la larghezza del testo senza cambiare le dimensioni del breadcrumb
    document.fonts?.ready.then(update);
}
